import { PatientHistoryType } from 'src/graphql.generated'
import { ADVANCED_NOTE_KIND_FIELD, ADVANCED_NOTE_KIND_LABELS } from './eventLogger/advancedNoteKinds'

// Mirrors `participantHistory/constants.ts`, with a parenthetical where two types share one label there.
export const PATIENT_HISTORY_TYPE_LABELS: Partial<Record<PatientHistoryType, string>> = {
  [PatientHistoryType.Accepted]: 'Participant Accepted',
  [PatientHistoryType.AdvancedFollowUpNote]: 'Meru Advanced Follow Up Note',
  [PatientHistoryType.AnonymousNote]: 'Anonymous Notes for Analytics',
  [PatientHistoryType.Asrm]: 'ASRM',
  [PatientHistoryType.Burnout]: 'Burnout Questionnaire',
  [PatientHistoryType.CheckInCall]: 'Check-in Call (note)',
  [PatientHistoryType.Custom]: 'Form Submission',
  [PatientHistoryType.Declined]: 'Participant Declined',
  [PatientHistoryType.DischargeSummaryNote]: 'Discharge Summary Note',
  [PatientHistoryType.FinancialEligibilityConfirmed]: 'Financial Eligibility Confirmed',
  [PatientHistoryType.Gad7]: 'GAD-7',
  [PatientHistoryType.IntakeNote]: 'Intake Notes (legacy)',
  [PatientHistoryType.IntakeNoteCoaching]: 'Intake Notes (Coaching)',
  [PatientHistoryType.IntakeNoteComprehensive]: 'Intake Notes',
  [PatientHistoryType.IntakeNotePsychiatry]: 'Intake Notes (Psychiatry)',
  [PatientHistoryType.Isi]: 'ISI',
  [PatientHistoryType.LabOrder]: 'Lab (order)',
  [PatientHistoryType.LabOrderNote]: 'Lab (note)',
  [PatientHistoryType.MissedIntakeCall]: 'Missed Intake Call',
  [PatientHistoryType.MonthlySummaryNote]: 'Monthly Summary Note',
  [PatientHistoryType.Note]: 'Note',
  [PatientHistoryType.Ocir]: 'OCI-R',
  [PatientHistoryType.ParticipantReEnrolled]: 'Participant Re-enrolled',
  [PatientHistoryType.Pcl5]: 'PCL-5',
  [PatientHistoryType.PhoneCall]: 'Phone Call',
  [PatientHistoryType.Phq9]: 'PHQ-9',
  [PatientHistoryType.ProgramEnd]: 'Program End',
  [PatientHistoryType.Sms]: 'SMS',
  [PatientHistoryType.TreatmentPlan]: 'Treatment Plan (legacy)',
  [PatientHistoryType.TreatmentPlanComprehensive]: 'Treatment Plan',
  [PatientHistoryType.TreatmentPlanComprehensiveUpdate]: 'Treatment Plan Update',
  [PatientHistoryType.VideoCall]: 'Check-in Call (video)',
  [PatientHistoryType.Who5]: 'WHO-5',
  [PatientHistoryType.Wpai]: 'WPAI',
}

// `value` tells an Advanced-only note kind apart from a plain note of the type it is stored as.
export const labelForHistoryType = (
  type: PatientHistoryType | null | undefined,
  value?: Record<string, unknown>
): string => {
  const advancedNoteKind = value?.[ADVANCED_NOTE_KIND_FIELD]
  const kindLabel = typeof advancedNoteKind === 'string' ? ADVANCED_NOTE_KIND_LABELS[advancedNoteKind] : undefined

  return kindLabel ?? (type && PATIENT_HISTORY_TYPE_LABELS[type]) ?? type ?? 'Unknown'
}
